import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { DashboardPage } from './pages/DashboardPage';
import { UploadPage } from './pages/UploadPage';
import { CreateRequestPage } from './pages/CreateRequestPage';
import { LoginPage } from './pages/LoginPage';
import { AdminPage } from './pages/AdminPage';
import { SetPasswordPage } from './pages/SetPasswordPage';
import { NotFoundPage } from './pages/NotFoundPage';

function AppContent() {
  const location = useLocation();
  const isEmbed = new URLSearchParams(location.search).get('embed') === 'true';

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {!isEmbed && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/create-request" element={<CreateRequestPage />} />
          <Route path="/upload/:token" element={<UploadPage />} />
          <Route path="/set-password/:token" element={<SetPasswordPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!isEmbed && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
